"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = require("lodash");
var _isDraft = _interopRequireDefault(require("./isDraft"));
var _constants = require("./constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function referralType(referral) {
  return (0, _isDraft["default"])(referral) ? _constants.DRAFT_REFERRAL_DISPLAY : _constants.REFERRAL_DISPLAY;
}
function getReferralName(referral) {
  var name = (0, _lodash.get)(referral, 'service_type.name', '');
  var serviceTypeName = (0, _lodash.isEmpty)(name) ? '' : name;
  return (0, _lodash.trim)("".concat(serviceTypeName, " ").concat(referralType(referral)));
}
var _default = exports["default"] = getReferralName;